import React from 'react';

export default function OrderCompletePopup({ onClose }) {
  return (
    <div className="auth-popup-overlay" onClick={onClose}>
      <div className="auth-popup-content" onClick={(e) => e.stopPropagation()}>
        <h2>Дякуємо за ваше замовлення!</h2>
        <p style={{ color: '#666666', fontSize: '1rem', marginBottom: '1.5rem' }}>
          Ми зв'яжемося з вами незабаром
        </p>
        <button className="auth-btn" onClick={onClose}>
          Закрити
        </button>
      </div>
    </div>
  );
}
